export default {
  common: {
    getDataFailed: 'Get Data Failed',
    cancel: 'cancel',
    noResult: 'no result',
    prize: 'prize',
    totalPrize: 'total prize',
    round: 'round',
    time: 'time',
    address: 'address',
    options: 'options',
    type: 'type',
    none: 'none',
    executedSuccessfully: 'EXCUTED SUCCESSFULLY',
    point: 'point',
    points: 'points',
  },
  header: {
    referral: 'REFERRAL',
    connect: 'CONNECT WALLET',
    records: 'MY RECORDS',
    register: 'PAY / STAKE',
    disconnect: 'DISCONNECT',
    networkHint: 'PAY ATTENTION TO YOUR NETWORK DELAY',
  },
  rules: {
    top: 'Are you ready for the challenge? We have 12 questions in total for a round, winners can share a $10,000 USDT prize pool.',
    title: 'rules',
    section1: 'The registration deadline is 09:00 AM GMT, the activity starts at 09:05 AM GMT.',
    section2: "You need to stake one Lifeform Cartoon Avatar and pay 500 Points to sign up for this activity. If you don't have a Lifeform Cartoon Avatar, you need to pay 20 USDT to sign up for this activity.",
    section3: '12 questions in total for a round. You have 20 seconds to choose your answer, and the correct answer will be shown in the rest 5 seconds. If you get it right, move on to the next question.',
    section4: 'When this round ends, you can unstake your avatar.',
    section5: 'Prize will be airdropped to the winners after each round.',
    section6: 'Send a referral link to your friend to get the Resurrection Card. [Once he/she used your link and signed up for Super Avatar event, your link will be activated.]',
    section7: 'You can use the Resurrection Card to continue. ONE Resurrection Card is for One Chance ONLY per round.',
    section8: 'Unused Resurrection Card will be invalid automatically after each round.',
  },
  home: {
    prizePool: 'prize pool',
    totalParticipants: 'total participants',
    round: 'round',
    startIn: 'start in',
    connect: 'connect',
    register: 'register',
    registered: 'registered',
    enter: 'enter',
    ongoing: 'ongoing',
    ended: 'ended',
    cumulativeRanking: 'cumulative ranking',
  },
  register: {
    registerRecords: 'register records',
    registerForRound: 'register for round',
    youCanChoose: 'you can choose',
    pay: 'pay',
    or: 'or',
    stake: 'stake',
    staked: 'staked',
    paid: 'paid',
    inviteFriends: 'Invite Friends',
    insufficientFunds: 'Insufficient Funds',
    registerSuccess: 'Successfully Registered',
    registerFail: 'Register Failed',
    onceRegistered: 'once registered, you can get a Lifeform Cartoon Medal for this round',
    checkMyMedal: 'check My Medal',
    backToHome: 'BACK TO HOME',
    pointsNotEnough: 'Points not enough',
  },
  records: {
    myTotalPrize: 'my total prize',
    myRecordsInSuperAvatar: 'my records in super avatar',
    round: 'round',
    totalRegistered: 'total registered',
    totalPrize: 'total prize',
    winners: 'winners',
    defeat: 'defeat',
    myPrize: 'my prize',
    myRecordsOfPayStake: 'my records of pay/stake',
    checkStage1: 'Check Super Avatar I',
    backToStage2: 'Back to Super Avatar II',
  },
  share: {
    share: 'share',
    referralUrlCopied: 'REFERRAL URL COPIED',
    showItOff: 'show it off',
    invitingYouTo: 'IS INVITING YOU TO',
    theWinnersTakeAll: 'winners share all',
    yourReferralUrl: 'your referral url',
    downloadAndShare: 'DOWNLOAD THE PHOTO AND SHARE',
    comeToWin: 'COME TO SUPER AVATAR AND WIN THE PRIZE!',
    iHaveDefeated: 'I HAVE DEFEATED',
    ofThePlayers1: 'OF THE PLAYERS',
    ofThePlayers2: 'AND ALMOST GET',
    isTheWinnerOfThisRound: 'IS THE WINNER OF THIS ROUND',
    hasWon: 'has won',
    comeToTogether: 'come to win more prize together',
    hereRecordOf: 'HERE IS THE GAME RECORDS',
    knowMore: 'KNOW MORE ABOUT SUPER AVATAR',
    iHaveWon: 'I HAVE WON',
    everyDay: 'EVERY DAY',
    resurrectionCardUsed: 'RESURRECTION CARD USED',
    everyDay12GMTAAnswer: 'Every day at 9AM (GMT), answer 12 questions correctly, and immediately share 10000 USDT equally. Participate in the link:',
    totalHighAs: 'TOTAL PRIZE POOL',
    everyDay12GMT: 'Every day at 9AM (GMT)',
    answer12Today1: 'Answer 12 questions correctly, the winners will ',
    answer12Today2: 'share all the prize of the day equally',
    numIHaveDefeated: 'I have defeated',
    numOfThePlayers1: 'players',
    numOfThePlayers2: 'and almost got',
    holdDownShare: 'Hold down the photo to share',
    win: 'win',
  },
  stake: {
    registerByStaking: 'register by staking',
    unstakeAllAvatar: 'unstake all avatar',
    chooseYourAvatar: 'choose your avatar',
    stake: 'stake',
    unstake: 'unstake',
    unstaked: 'unstaked',
    approveToken: 'Please Approve Your Token to Register',
    approveNFT: 'Please Approve Your NFT to Register',
  },
  match: {
    watching: 'watching',
    sorryYouAreOut: 'Sorry, You are Out!',
    wishNext: 'Wish you win in the next game!',
    totalPrize: 'total prize',
    survivedAndTotal: 'survived/total registered',
    prizeForEach: 'prize for each',
    rememberTo: 'remember to',
    unstakeYourAvatar: 'unstake your avatar',
    congrats: 'congrats!',
    areWinner: 'You are the  winner of this round.',
    almostWinner: 'You are almost the winner!',
    keepLearning: 'Keep learning and win in the next round!',
    toGetCard: 'to get a resurrection card for next round',
  },
  referral: {
    currentRound1: 'this is in round',
    currentRound2: 'now',
    inviteYourFriendsTo: 'invite your friends to get a resurrection card for this round!',
    referralRecords: 'referral records',
    round: 'round',
    resurrectionCard: 'Resurrection Card',
    usedOrNot: 'used or not',
    invitedUsers: 'invited users',
    used: 'used',
    unused: 'unused',
    none: 'none',
    viewDetails: 'view details',
  },
};